import { Col, Row } from "antd";
import FileUploadComponent, { FileData } from "../../../components/FileUploadComponent";
import { useDocCategoryContext } from "../../../context/DocumentCategoryContext/DocumentCategoryContext";
import { FileUploadConst } from "./constants";

const DocumentDetail = () => {
	const { setDocCategoryForm } = useDocCategoryContext();

	const handleFileChange = (files: FileData[] | null) => {
		setDocCategoryForm(prevState => ({
			...prevState,
			documents: files?.map(file => file.file).filter(f => f !== null) as File[] || undefined
		}));
	};

	return (
		<>
			<Row gutter={20}>
				<Col span={20}>
					<FileUploadComponent
						title={FileUploadConst.label}
						onChange={handleFileChange}
						fileSize={FileUploadConst.fileSize}
						fileSizeText={FileUploadConst.fileSizeText}
						format={FileUploadConst.format}
						multiple
					/>
				</Col>
			</Row>
		</>
	);
};

export default DocumentDetail;
